import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapToolTip = React.lazy(function () {
    return import('../../bootstrap-components/components/BTToolTip');
});
var bootStrapToolTip = function (props) {
    return (React.createElement(BootStrapToolTip, __assign({}, props)));
};
export var ToolTip = function (props) {
    var componentToDisplay = bootStrapToolTip(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
//# sourceMappingURL=ToolTip.js.map